<template>
  <!-- En-tête -->
  <!-- <span class = "d-block p-2 bg-primary"></span> -->
  <header class="nav-after" v-if="instance">
    <div class="container entete">
      <img :src="logo" alt="Logo instance" style="width: 13rem;" />
      <img :src="secondLogo" alt="Logo Autoref" style="width: 13rem;" />
    </div>
  </header>
  <entete v-else :logo="logo" :tailleLogo="tailleLogo"></entete>
  <!-- <entete :logo="logo" :tailleLogo="tailleLogo"></entete> -->
  <!-- <span class="d-block p-2 bg-dark"></span> -->
  <main>
    <form @submit.prevent="VerifierLogin" class="container tablette">
      <div class="row-inputs">
        <div class="row row-label">
          <label for="log_log">Identifiant</label>
          <label for="pwd_log">Mot de passe</label>
        </div>
        <div class="column md-row row-form">
          <input type="text" class="form-control fs21" placeholder="Identifiant" v-model="log_log"  v-focus id="log_log" />

          <input type="password" class="form-control" placeholder="Mot de passe" v-model="pwd_log" id="pwd_log"
            ref="pwd" @keyup.enter="VerifierLogin" />
          
          <button type="submit" id="connexion" ref="connexion" class="btn btn-plain btn-connexion"> 
            Se connecter
          </button>
        </div>
        <div class="md-row row-form-create">
          <button type="button" id="creercompte" class="btn btn-outline btn-account" @click="mdpOublie">
            Mot de passe oublié
          </button>
        </div>
        <!-- <div class="md-row row-form-create"> -->
          <!-- <button type="button" id="premiereConnexion" class="btn btn-outline btn-account" @click="premiereConnexion"> -->
            <a href="#" @click="premiereConnexion" class="premiereConnexion">
              Première connexion ?
            </a>
          <!-- </button> -->
        <!-- </div> -->
        <!-- ERREUR DE SAISIE - AFFICHAGE DU MESSAGE D'ERREUR POUR L'UTILISATEUR -->
        <div class="alert alert-danger" v-if="retourError">
          Identifiant ou mot de passe incorrect
        </div>
      </div>
      <div class="column md-row row-textuel">
        <div class="col-intro col-100 col-md-60">
          <h1>Un webshop conçu pour les pros</h1>
          <p>
            Qui vous permet de trouver rapidement la bonne pièce au bon prix pour votre
            réparation.<br />Plus d'éfficacité, plus de services, plus de garanties pour
            gérer votre activité avec sérénité et professionnalisme.
          </p>
        </div>
        <div class="col-video col-100 col-md-50">
          <figure @click="openVideoModal = true">
            <img src="../assets/jpg/thumbnail_video_Close_Resize.jpg" class="img-featured video" />
          </figure>
          <div v-if="openVideoModal" class="modal-backdrop">
            <div class="modal-video" style="position: relative;">
              <button @click="openVideoModal = false" class="close-video-button"><i
                  class="fa-solid fa-xmark"></i></button>
              <div class="modal-body-video">
                <video controls autoplay style="width: 100%; height: auto; margin-top: 2rem;">
                      <source src="https://media.grifc.com/videos/autoref-presentation-officiel.webm" type="video/webm" />
                      <source src="https://media.grifc.com/videos/autoref-presentation-officiel.mp4" type="video/mp4" />
                      Votre navigateur ne supporte pas la lecture vidéo.
                    </video>
              </div>
            </div>
          </div>
          <a class="link-video" title="En savoir plus sur le Webshop"><span>Voir la vidéo de présentation</span>
          </a>
        </div>
      </div>
      <!-- MODAL POUR MOT DE PASSE OUBLIÉ -->
      <div v-if="showMdpOublieModal" class="modal-backdrop">
        <div class="modal">
          <div class="modal-body">
            <h2>Réinitialisation du mot de passe</h2>
            <label for="codeClient">Code client</label>
            <input type="text" id="codeClient" v-model="codeClient"
              class="form-control row-form reinitMdp input-separation" placeholder="Votre code client" />
            <label for="maiAdhcli">Adresse mail</label>
            <input type="email" id="maiAdhcli" v-model="maiAdhcli" class="form-control reinitMdp row-form"
              placeholder="Votre adresse mail" />
          </div>
          <div class="modal-footer">
            <button @click="closeMdpOublie" class="btn btn-annuler" type="button">Annuler</button>
            <button @click="envoyerDemandeReset" class="btn btn-primary" type="button">Envoyer</button>
          </div>
        </div>
      </div>
      <!-- FIN MODAL POUR MOT DE PASSE OUBLIÉ -->
      <!-- MODAL POUR PREMIERE CONNEXION -->
      <div v-if="showPc" class="modal-backdrop">
        <div class="modal">
          <div class="modal-body">
            <h2>Première connexion</h2>
            <label for="maiAdhcli">Adresse mail</label>
              <input type="email" id="maiAdhcliPc" v-model="maiAdhcli" class="form-control reinitMdp row-form" placeholder="Votre adresse mail" />
          </div>
          <div class="modal-footer">
            <button @click="closeModal" class="btn btn-annuler" type="button">Annuler</button>
            <button @click="envoyerLogin" class="btn btn-primary" type="button">Envoyer</button>
          </div>
        </div>
      </div>
      <!-- FIN MODAL POUR PREMIERE CONNEXION -->
    </form>
  </main>
  <competence></competence>
</template>

<script>
import { useRouter } from "vue-router";
import Swal from "sweetalert2";
import entete from "@/components/comp.entete.vue";
import competence from "@/components/comp.competence.vue";
const router = useRouter();

const gtagConfig = {
  "delestrez.autoref.fr": "G-4HKBH7N6BG",
  "durandservices.autoref.fr": "G-WJ4EL43X2J",
  "guiproman.autoref.fr": "G-ZZZZZZZZZZ",
  "ved-70.autoref.fr": "G-D8BMJXXF5V",
  "aisnedieselservices.autoref.fr": "G-BBBBBBBBBB",
  "marceul.fr": "G-D8BMJXXF5V",
};

export default {
  name: "index",
  directives: {
    focus: {
      mounted(el) {
        el.focus();
      },
    },
  },
  components: {
    entete,
    competence,
  },
  
  data() {
    return {
      openVideoModal: false,
      showMdpOublieModal: false,
      codeClient: '',
      maiAdhcli: '',
      log_log: "",
      pwd_log: "",
      retourError: false,
      deferredPrompt: null,
      showInstallPopup: false,
      isIos: false,
      isInStandaloneMode: false,
      isDesktop: false,
      urlApi: process.env.VUE_APP_API_URL,
      secondLogo: '',
      logo: '',
      instance: '',
      code_instance: '',
      showPc: false,
    };
  },
  
  created() {
    this.$store.dispatch("resetState");
    sessionStorage.clear();          // tout vider
    this.loadGtag();
  },
  mounted() {
    // Si cookies éventuels
    document.cookie.split(";").forEach(cookie => {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    });
    // Ajoute la classe "connexion" du body quand le composant se monte
    document.body.classList.add("connexion");
    window.addEventListener("beforeunload", (event) => {
      var refresh = this.$route.name;
      this.$router.push({ name: refresh });
    });
    const d = new URLSearchParams(window.location.search).get('d');

    if (d) {
      const decoded = JSON.parse(atob(d));
      this.instance = decoded.instance;
      this.code_instance = decoded.code;
    }
    this.logo = require('@/assets/png/logo-autoref.png');
    this.tailleLogo = "22rem";
    if (this.instance) {
      this.logo = require(`@/assets/svg/logo/Logo_${this.instance}_by.svg`);
      this.secondLogo = require('@/assets/svg/logo/Logo_Autoref_Instance.svg');
      this.tailleLogo = "13rem";
    }
  },
  
 
  methods: {
    // Ouvre le modal mot de passe oublié
    mdpOublie() {
      this.showMdpOublieModal = true;
    },
    closeMdpOublie() {
      this.showMdpOublieModal = false;
      this.codeClient = '';
      this.maiAdhcli = '';
    },
    premiereConnexion()
    {
      this.showPc=true;
    },
    async envoyerLogin()
    {
      const sessionData = {
        ins_adh: this.code_instance,
        mail: this.maiAdhcli,
      };
      try {
        const response = await fetch(`${this.urlApi}/api/envoyerLogin`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(sessionData),
        });

        if (!response.ok) {
          throw new Error("Une erreur est survenue,Veuillez contacter votre correspondant");
        }
        const data = await response.json();
        if(data.codeErr=="OK")
        {
          Swal.fire({
            title: "Envoi effectué",
            text: "Votre login/mdp vient d'etre envoyer sur votre boite mail.",
            icon: "success",
          });
          this.closeModal();
        }
        else
        {
          Swal.fire({
            title: "Erreur",
            text: "Une erreur est survenue: "+data.infoERR,
            icon: "error",
          });
          return;
        }
      } catch (error) {
        Swal.fire({
          title: "Erreur API",
          text: "Erreur lors de l'appel de envoyerLogin "+error,
          icon: "error",
        });
        return;
      }
    },  
    closeModal() {
      this.showPc = false;
      this.maiAdhcli = '';
    },
    async envoyerDemandeReset() {
      const sessionData = {
        codeClient: this.codeClient,
        mail: this.maiAdhcli
      };
      try {
        const response = await fetch(`${this.urlApi}/api/resetMdp`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(sessionData),
        });

        if (!response.ok) {
          throw new Error("Network response was not ok resetMdp");
        }
        const data = await response.json();
        if (data.codeErr == "OK") {
          Swal.fire({
            title: "Envoi effectué",
            text: "Votre mot de passe à été réinitialisé et envoyé dans votre boite mail.",
            icon: "success",
          });
          this.closeMdpOublie();
        }
        else {
          Swal.fire({
            title: "Erreur",
            text: "Une erreur est survenue: " + data.infoERR,
            icon: "error",
          });
          return;
        }
      } catch (error) {
        Swal.fire({
          title: "Erreur API",
          text: "Erreur lors de l'appel de resetMdp " + error,
          icon: "error",
        });
        return;
      }
    },
    loadGtag() {
      const hostname = window.location.hostname;
      const gtagId = gtagConfig[this.instance] || null;
      if (gtagId) {
        const existingScript = Array.from(
          document.head.getElementsByTagName("script")
        ).find((script) =>
          script.src.includes(`googletagmanager.com/gtag/js?id=${gtagId}`)
        );
        if (!existingScript) {
          const script = document.createElement("script");
          script.async = true;
          script.src = `https://www.googletagmanager.com/gtag/js?id=${gtagId}`;
          document.head.appendChild(script);
          window.dataLayer = window.dataLayer || [];
          function gtag() {
            window.dataLayer.push(arguments);
          }
          gtag("js", new Date());
          gtag("config", gtagId);
          this.$sessionStorage.set("gtag", gtagId);
          console.log(gtagId);
        }
      } else {
        console.warn(`Aucun gtag configuré pour ${hostname}`);
      }
    },
    async VerifierLogin() {
      const urlApi = this.urlApi;
      // envoie des données dans le POSTS
      if (!this.log_log.startsWith(this.code_instance)) {
        switch (this.code_instance) {
          case 'MAR':
            window.location.href = 'https://marceul.fr/connexion';
            break;
          case 'VED':
            window.location.href = 'https://pieces-auto.ved-70.fr/#';
            break;
          case 'DLZ':
            window.location.href = 'https://www.delestrez.fr/connexion';
            break;
          case 'EVO':
            window.location.href = 'https://marceuldev.grifc.com/connexion';
            break;
          case 'DUR':
            window.location.href = 'https://www.durandservices.fr/connexion';
            break;
          case 'ADS':
            window.location.href = 'https://www.aisnedieselservices.fr/connexion';
            break;
          case 'GPM':
            window.location.href = 'https://www.guiproman-bm.fr/connexion';
            break;
          default:
            console.warn(`Instance inconnue : ${this.code_instance}`);
            break;
        }
      }
      const sessionData = {
        log_log: this.log_log,
        pwd_log: this.pwd_log,
      };
      try {
        const response = await fetch(`${urlApi}/api/verifierLogin`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(sessionData),
        });

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        if (data.retour == "OK") {
            let rfc = data.rfc_add==0 ? 'N' : 'O';
            this.$sessionStorage.set("vphpsid",  ""),
            this.$sessionStorage.set("log_log", this.log_log),
            this.$sessionStorage.set("pwd_log", this.pwd_log),
            this.$sessionStorage.set("nom_cli", data.nom_cli),
            this.$sessionStorage.set("logo_cli", data.logo_cli),
            this.$sessionStorage.set("sta_cli", data.sta_cli),
            this.$sessionStorage.set("niv_cli", data.niv_cli),
            this.$sessionStorage.set("edi_cli", data.edi_cli),
            this.$sessionStorage.set("vpri_cli", data.vpri_cli),
            this.$sessionStorage.set("instance", data.ins_adh),
            this.$sessionStorage.set("id_gadherent", data.id_gadherent),
            this.$sessionStorage.set("id_fiadd", data.id_fiadd),
            this.$sessionStorage.set("id_fiaddc", data.id_fiaddc),
            this.$sessionStorage.set("id_fiaddgar", data.id_fiaddgar),
            this.$sessionStorage.set("id_fimag", data.id_fimag),
            this.$sessionStorage.set("cod_mag", data.cod_mag),
            this.$sessionStorage.set("etb_mag", data.etb_mag),
            this.$sessionStorage.set("vil_mag", data.vil_mag),
            this.$sessionStorage.set("ad1_mag", data.ad1_mag),
            this.$sessionStorage.set("ad2_mag", data.ad2_mag),
            this.$sessionStorage.set("sir_mag", data.sir_mag),
            this.$sessionStorage.set("tel_mag", data.tel_mag),
            this.$sessionStorage.set("heu1_mag", data.heu1_mag),
            this.$sessionStorage.set("heu2_mag", data.heu2_mag),
            this.$sessionStorage.set("note_mag", data.note_mag),
            this.$sessionStorage.set("eurb_codmad", data.eurb_codmad),
            this.$sessionStorage.set("daz_add", data.daz_add),  // Date de fin de l' agrement gaz
            this.$sessionStorage.set("cer_add", data.cer_add),  // Agrement GAZ O/N
            this.$sessionStorage.set("rfc_add", rfc),  // Agrement GAZ O/N
            this.$sessionStorage.set("cai_add", data.cai_add),  // Agrement GAZ O/N
            this.$sessionStorage.set("cod_act", data.cod_act),  // Agrement GAZ O/N
            this.$sessionStorage.set("id_profilcli_list", data.id_profilcli_list || []);
            this.$sessionStorage.set("mai_con", data.mai_con),
            this.$sessionStorage.set("tel_con", data.tel_con),
            this.$sessionStorage.set("id_adhcli", data.id_adhcli),
            this.$sessionStorage.set("api_adh", data.api_adh),
            this.$sessionStorage.set("cut_adh", data.cut_adh),
            this.$sessionStorage.set("gst_adh", data.gst_adh),
            this.$sessionStorage.set("id_printerDefaut", data.id_printerDefaut),
            
           // this.$sessionStorage.set("id_printerDefaut", data.id_printerDefaut || ''),
            // Chargement du style si PL ou VL
            //this.$sessionStorage.set("demandeAdresseLivraison", "1");
            // MISE EN MEMOIRE DANS LE STORE
            this.$store.commit("setgLinkingTargetTypeDefaut",data.linkingTargetTypeDefaut);
            this.$store.commit("setgCod_metDefaut", data.cod_metDefaut);
            this.$sessionStorage.set("cod_met", data.cod_metDefaut || "VL");
            const cod_met = data.cod_metDefaut;
            const gPortailDefaut='portail' + cod_met;
            this.$store.commit("setgPortailDefaut", gPortailDefaut);
          // this.$store.commit("setgGart_adh", data.gart_adh);
          this.$store.commit("setgEtb_mag", data.etb_mag);

          this.$store.commit("setgTag_adh", data.gtag_adh);
          this.$store.commit("setgGpi_adh", data.gpi_adh);
          this.$store.commit("setgPic_adh", data.pic_adh);
          this.$store.commit("setgPla_adh", data.pla_adh);
          // Créer une session si elle n'existe pas encore
          const gSession =
            "session_" + Date.now() + "_" + Math.random().toString(36).substr(2, 9);
          this.$store.commit("setgSession", gSession); // Session our le panier
          // Chargement du style si PL ou VL
          // Style spécifique PL uniquement
          if (data.cod_metDefaut === "PL") {
            document.body.classList.add("pl");
            
          } else {
            document.body.classList.remove("pl");
          }
    
          // Route portail dynamique : portailVL / portailPL / portailCARRO / ...
          const portailRouteName = data.cod_metDefaut ? `portail${data.cod_metDefaut}` : "portailVL";

          this.$store.commit("gPortailDefaut", portailRouteName);
          this.$router.push({ name: portailRouteName });

       
          // if (data.cod_metDefaut == "PL") {
          //   document.body.classList.add("pl");
          //   this.$store.commit("gPortailDefaut", "portailPL");
          //   this.$router.push({ name: "portailPL" });
          // } else {
          //   this.$store.commit("gPortailDefaut", "portailVL");
          //   this.$router.push({ name: "portailVL" });
          // }

          //this.$router.push({ name: "portail", query: { id_filogin: 0 } });
        } else {
          //ERREUR DE SAISIE
          this.retourError = true;
          this.log_log = "";
          this.pwd_log = "";
          document.getElementById("log_log").focus();
        }
      } catch (error) {
        console.error("Error fetching items:", error);
      }
    },
  },
};
</script>
<style scoped>
.install-popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 20px;
  border: 1px solid #ccc;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
}

.ios-help {
  position: fixed;
  bottom: 10px;
  left: 10px;
  right: 10px;
  background: #fff3cd;
  border: 1px solid #ffeeba;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  z-index: 1000;
}

.icon {
  width: 20px;
  vertical-align: middle;
}
</style>